import { useEffect, useState, useContext } from "react"
import { OrderCard } from "../components/order/OrderCard"
import { CustomButton } from "../../components/global/CustomButton"
import { OrderProductRow } from "../components/order/OrderProductRow"
import { OrderTotal } from "../components/order/OrderTotal"
import { useParams } from "react-router-dom"
import { OrdersContext } from "../../contexts/OrdersContext"
import { UserContext } from "../../contexts/UserContext"
import { NotificationRender } from "../../components/global/NotificationRender"
import "./orderDetails.css"

export function OrderDetails() {
    const [status, setStatus] = useState("Cancelled")
    const [order, setOrder] = useState(null)
    const [day, setDay] = useState(null)
    const [month, setMonth] = useState(null)
    const [year, setYear] = useState(null)

    const { id } = useParams()

    const ordersContextData = useContext(OrdersContext)
    const orders = ordersContextData.state
    const { dispatch: ordersDispatch } = ordersContextData

    const userContextData = useContext(UserContext)
    const { user, token, dispatch, notification } = userContextData

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

    useEffect(() => {
        if(orders) {
            const findOrder = orders.find(e => e.orderId === id)
            setOrder(findOrder)

            const joinDateSplits = findOrder.createdAt.split("-")

            setDay(joinDateSplits[2].slice(0, 2))
            setMonth(months[parseInt(joinDateSplits[1]) - 1])
            setYear(joinDateSplits[0])
        }
    }, [orders])

    async function handleUpdateOrder() {
        const { _id } = user
        const { orderId } = order
        //${process.env.REACT_APP_API_BASE_URL}
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/updateOrder`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ orderId, status })
        })
        const json = await response.json()

        if(response.status === 200) {
            const { order, user } = json
            ordersDispatch({ type: "UPDATE_ORDER", payload: order })
            dispatch({ type: "UPDATE_ORDER", payload: order })
            localStorage.setItem("user", JSON.stringify({ user, token }))
            console.log(json)
        } else {
            const { error } = json
            dispatch({ type: "UPDATE_ORDER_ERROR_ACTION_FORBIDDEN" })
            console.log(json)
        }
    }

    return (
        <div className="order-details">

            {
                notification && notification.type.includes("UPDATE_ORDER") &&
                    <NotificationRender notification={notification} />
            }

            <h4>Order Details</h4>

            {
                order && (
                    <>
                        <div className="mt-5 d-flex align-items-center gap-4">
                            <div className="fs-5">Order ID: {order.orderId}</div>
                            <div className={`p-2 rounded-1 order-${(order.status.toLowerCase())}`}>
                                {order.status}
                            </div>
                        </div>
                       <div className="fs-5">Order date: {month + " " + day + " " + year}</div> 
                    </>
                )
            }

            <div className="d-flex justify-content-end gap-2 actions md-row">
                <div>
                    <span className="me-2">Status:</span>
                    <select
                        id="status"
                        className="rounded-1"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}>
                            <option value="Cancelled">Cancelled</option>
                            <option value="Delivered">Delivered</option>
                            <option value="Pending">Pending</option>
                            <option value="Returned">Returned</option>
                    </select>
                </div>
                <div className="d-flex justify-content-end gap-2">
                    <div className="printer rounded-1"></div>
                    <CustomButton
                        color="default"
                        text="Save"
                        btnFunction={handleUpdateOrder}
                    />
                </div>
            </div>

            {
                order && (
                    <div className="mt-4 d-flex gap-3 order-cards md-row">

                        <OrderCard
                            icon="customer"
                            title="Customer"
                            info1={"Full Name: " + order.customer.fullName}
                            info2={"Email: " + order.customer.email}
                            info3={"Phone: " + order.customer.phone}
                            btnText="View Profile"
                            path={`/admin/customers/${order.customer._id}`}
                        />
                        <OrderCard
                            icon="order"
                            title="Order Info"
                            info1={"Payment Method: " + order.paymentMethod}
                            info2={"Status: " + order.status}
                            btnText="Download Info"
                        />
                        <OrderCard
                            icon="location"
                            title="Deliver To"
                            info1={"Address: " + order.customer.address}
                            btnText="View Profile"
                        />

                    </div>
                )
            }
            
            <div className="mt-5 mb-3"><h4>Products</h4></div>

            <div className="border rounded-1 mt-2 table-wrapper">
                <table className="orders-products-table mt-1 mb-3">
                    <tbody>
                        <tr className="table-header">
                            <td>Product</td>
                            <td>Order ID</td>
                            <td>Quantity</td>
                            <td>Total</td>
                        </tr>
                    </tbody>
                </table>

                {
                    order && order.products.map((e, i) => (
                        <OrderProductRow
                            key={i}
                            product={e}
                            orderId={order.orderId}
                        />
                    ))
                }

            </div>

            <OrderTotal subtotal={order && order.totalAmount} />

        </div>
    )
}